import { TableCell, TableRow, Grid } from "@material-ui/core";
import { PencilIcon, TrashIcon } from "App/Assets"; // eslint-disable-line
import { IconButtonDatatable, ModalDeleteConfirm } from "App/Component/ui";
import { useDatatables } from "App/hooks";
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { useState, useContext } from "react";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { FormContext } from "../context/FormContext";
import {
  deleteById,
  FORM_RESET_DETAIL,
  RenderStatusMTBarang,
} from "../helpers";
import { headCells } from "../helpers";
import { FormUploadFile } from ".";
import FormDetail from "./FormDetail/FormDetail";
import { FreezeTableClient } from "components/organism";
import ListDetailPengerjaan from "./FormDetail/ListDetailPengerjaan";
import { STATUS_PENGERJAAN_SELESAI } from "../../HelpDesk/helpers";
export default function RenderListReq({
  classes,
  setNewDataReqList,
  namaInputRef,
}) {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [deleteID, setDeleteID] = useState([]);
  const { formData, setFormDetail, setListDetailWork, detailMT } =
    useContext(FormContext);
  const [file, setFile] = useState(null);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: detailMT,
    orderByDefault: "nama_asset",
    orderByRow: ["nama_asset", "code_asset"],
  });

  const handleClickDelete = (row) => {
    setDeleteID(row?.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  async function deleteList() {
    const res = await deleteById(deleteID);
    if (res.state) {
      defaultToastSuccess("Berhasil mengapus data !");
      setNewDataReqList(formData.id);
      setFormDetail(FORM_RESET_DETAIL);
      setListDetailWork([]);
    } else {
      defaultToastError(res.message);
    }
    setShowModalDeleteConfirm(false);
  }

  const handleClickUpdate = (row) => {
    setFormDetail({
      id: row?.id,
      id_service_header: row?.id_service_header,
      fixasset_id: row?.fixasset_id,
      is_garansi: row?.is_garansi,
      tanggal_akhir_garansi: row?.tanggal_akhir_garansi,
      nama_asset: row?.nama_asset,
      code_asset: row?.code_asset,
      no_faktur: row?.no_faktur,
      deskripsi_kerusakan: row?.deskripsi_kerusakan,
      kelengkapan: row?.kelengkapan,
      status_barang: row?.status_barang,
      remark: row?.remark,
    });
    setListDetailWork(
      isNull(row?.detail_perbaikan) ? [] : row?.detail_perbaikan
    );
  };

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <FreezeTableClient
        title='Detail Maintenanace'
        setQ={setQ}
        maxHeight='300px'
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={detailMT}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                // style={{
                //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                // }}
              >
                <TableCell scope='row' padding='none' align='center'>
                  {index + 1}
                </TableCell>

                <TableCell scope='row' padding='none' align='center'>
                  {formData.status_service < STATUS_PENGERJAAN_SELESAI ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                      }}>
                      <IconButtonDatatable
                        onClick={() => handleClickUpdate(row)}>
                        <PencilIcon />
                      </IconButtonDatatable>

                      <IconButtonDatatable
                        onClick={() => handleClickDelete(row)}>
                        <TrashIcon />
                      </IconButtonDatatable>
                    </div>
                  ) : (
                    <></>
                  )}
                </TableCell>
                <RenderTableCell
                  row={row}
                  // validate={validasi}
                  status={formData.status_verifikasi}
                />
              </TableRow>
            );
          })}
      </FreezeTableClient>

      <Grid container spacing={1} style={{ marginTop: "1rem" }}>
        {formData.status_service !== STATUS_PENGERJAAN_SELESAI && (
          <>
            <Grid item lg={6}>
              <FormDetail setNewDataReqList={setNewDataReqList} />
            </Grid>
            <Grid item lg={6}>
              <ListDetailPengerjaan />
            </Grid>
          </>
        )}
        <Grid item lg={12}>
          <FormUploadFile
            file={file}
            setFile={setFile}
            setNewDataReqList={setNewDataReqList}
          />
        </Grid>
      </Grid>
    </>
  );
}

const RenderTableCell = ({ row }) => {
  return (
    <>
      <TableCell align='left'>{row?.id}</TableCell>
      <TableCell align='left'>{row?.nama_asset}</TableCell>
      <TableCell align='left'>{row?.code_asset}</TableCell>
      <TableCell align='left'>
        {isNull(row?.remark) ? "-" : row?.remark}
      </TableCell>
      <TableCell align='left'>
        {isNull(row?.kelengkapan) ? "-" : row?.kelengkapan}
      </TableCell>
      <TableCell align='center'>
        <RenderStatusMTBarang status={row?.status_barang} />
      </TableCell>
      <TableCell align='left'>
        {isNull(row?.no_faktur) ? "-" : row?.no_faktur}
      </TableCell>
      <TableCell align='left'>
        {row?.deskripsi_kerusakan === null ? "-" : row?.deskripsi_kerusakan}
      </TableCell>
      <TableCell align='left'>
        {row?.is_garansi === false ? "Tidak" : "Ya"}
      </TableCell>
      <TableCell align='left'>
        {row?.tanggal_akhir_garansi === null
          ? "-"
          : defaultDateDisplay(row.tanggal_akhir_garansi)}
      </TableCell>
    </>
  );
};
